import { HTTP } from "@/util/http";
import {
  ProductUsageFeatureKey,
  trackFeatureUsage,
} from "@/util/ProductUsageAnalytics";

export interface UploadResponseData {
  id: number,
  firestore_id: string,
  workspace_id: string,
}

export interface ThumbnailReplaceResponseData {
  thumbnail_storage_id: string,
  thumbnail_download_url: string,
}

export class UploadService {

  static async upload(
      formData: FormData,
      token: string,
      workspaceId: string,
      documentId?: string | undefined,
      onProgress?: (p: number) => void): Promise<UploadResponseData> {
    const headers = new Map();
    headers.set("Authorization", `Bearer ${token}`);

    let fetchUrl = `/api/upload/${workspaceId}`;
    if (documentId !== undefined) {
      fetchUrl += `/${documentId}/add-revision`;
    }

    const response = await HTTP.postFormData(
      fetchUrl,
      headers,
      formData,
      onProgress);

    const data = JSON.parse(response);
    trackFeatureUsage(ProductUsageFeatureKey.DocumentUploaded, {
      source: "upload_service",
      uploadContext: documentId === undefined ? "new_document" : "document_revision",
    });
    return data;
  }

  static async uploadFileToStorage(
      formData: FormData,
      token: string,
      onProgress?: (p: number) => void): Promise<string> {
    const headers = new Map();
    headers.set("Authorization", `Bearer ${token}`);

    let fetchUrl = `/backend/upload_file_to_storage`;
    const response = await HTTP.postFormData(
      fetchUrl,
      headers,
      formData,
      onProgress); 

    const data = JSON.parse(response);
    return data.downloadUrl;
  }

  static async replaceThumbnail(
      formData: FormData,
      token: string,
      workspaceId: string,
      documentId: string,
      onProgress?: (p: number) => void): Promise<ThumbnailReplaceResponseData> {
    const headers = new Map();
    headers.set("Authorization", `Bearer ${token}`);

    const fetchUrl = `/api/upload/${workspaceId}/${documentId}/replace-thumbnail`;
    const response = await HTTP.postFormData(
      fetchUrl,
      headers,
      formData,
      onProgress);

    return JSON.parse(response);
  }

}
